import get from 'lodash/get';
import error from 'aurora-utils/error';
import * as types from './constants';

const defaultState = {
  loading: false,
  query: null,
  properties: null,
  activeProperty: null,
  error: null,
  poaCustomers: [],
  offPlanProjects: [],
  offPlanUnitUsage: [],
  offPlanUnitTypes: [],
  mortgageTypes: [],
  map: null,
};

export default function propertiesReducer(state = defaultState, action = {}) {
  switch (action.type) {
    case types.FETCH_PROPERTY_DETAILS:
      return {
        ...state,
        loading: true,
        activeProperty: null,
        map: null,
      };
    case types.FETCH_PROPERTY_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        activeProperty: get(action.payload, 'property'),
        error,
      };
    case types.FETCH_PROPERTY_DETAILS_ERROR:
      return {
        ...state,
        loading: false,
        activeProperty: null,
        error: get(action.payload, 'error'),
      };
    case types.FETCH_PROPERTY_DETAILS_SUCCESS_MAP:
      return {
        ...state,
        map: action.payload?.map,
      };
    case types.PROPERTY_OPERATION_START:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.PROPERTY_OPERATION_END:
      return {
        ...state,
        loading: false,
        error: get(action.payload, 'error', 'oops_something_went_wrong'),
        properties: null,
      };
    case types.FETCH_LEASE_PROPERTIES_V2:
      return {
        ...state,
        loading: false,
        error: null,
        query: get(action.payload, 'query', null),
        properties: get(action.payload, 'properties', null),
      };
    case types.FETCH_BUILDING_UNITS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.FETCH_POA_CUSTOMER:
      return {
        ...state,
        loading: true,
        error: null,
        poaCustomers: [],
      };
    case types.FETCH_POA_CUSTOMER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        poaCustomers: get(action.payload, 'customers', []),
      };
    case types.FETCH_POA_CUSTOMER_FAILURE:
      return {
        ...state,
        loading: false,
        error: null,
        poaCustomers: [],
      };
    case types.FETCH_OFF_PLAN_PROJECTS:
      return {
        ...state,
        loading: true,
        error: null,
        offPlanProjects: [],
      };
    case types.FETCH_OFF_PLAN_PROJECTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        offPlanProjects: get(action.payload, 'projects', []),
      };
    case types.FETCH_OFF_PLAN_PROJECTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: null,
        offPlanProjects: [],
      };
    case types.FETCH_OFF_PLAN_UNIT_USAGE:
      return {
        ...state,
        loading: true,
        error: null,
        offPlanUnitUsage: [],
      };
    case types.FETCH_OFF_PLAN_UNIT_USAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        offPlanUnitUsage: get(action.payload, 'unitUsage', []),
      };
    case types.FETCH_OFF_PLAN_UNIT_USAGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: null,
        offPlanUnitUsage: [],
      };
    case types.FETCH_OFF_PLAN_UNIT_TYPES:
      return {
        ...state,
        loading: true,
        error: null,
        offPlanUnitUsage: [],
      };
    case types.FETCH_OFF_PLAN_UNIT_TYPES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        offPlanUnitTypes: get(action.payload, 'unitTypes', []),
      };
    case types.FETCH_OFF_PLAN_UNIT_TYPES_FAILURE:
      return {
        ...state,
        loading: false,
        error: null,
        offPlanUnitTypes: [],
      };
    case types.FETCH_MORTGAGE_TYPES:
      return {
        ...state,
        error: null,
        offPlanUnitUsage: [],
      };
    case types.FETCH_MORTGAGE_TYPES_SUCCESS:
      return {
        ...state,
        error: null,
        mortgageTypes: get(action.payload, 'mortgageTypes', []),
      };
    case types.FETCH_MORTGAGE_TYPES_FAILURE:
      return {
        ...state,
        error: null,
        mortgageTypes: [],
      };
    case types.CLEAR_PROPERTIES_DATA:
      return {
        ...state,
        loading: false,
        error: null,
        properties: null,
      };
    default:
      return state;
  }
}
